import { Component, h } from 'preact';
import cx from 'classnames';

import { Chip } from './chip.component';


interface MultiChipInputProps {
  textValue: string;
  chipValues: string[];
  maxLength?: number;

  placeholder?: string;
  showInvalidState?: boolean;

  onInput: (event: Event) => void;
  onChipListChange?: (chips: string[]) => void;
  onChipRemove?: (chip: string) => void;
  onEnterKeyPress?: () => void;
}

export class MultiChipInput extends Component<MultiChipInputProps> {
  onRemoveChipValue(value: string) {
    const chips = [ ...this.props.chipValues ];
    const index = chips.indexOf(value);
    chips.splice(index, 1);

    if (this.props.onChipListChange) {
      this.props.onChipListChange(chips);
    }

    if (this.props.onChipRemove) {
      this.props.onChipRemove(value);
    }
  }

  getChips() {
    const chipValues = this.props.chipValues || [];

    return chipValues.map(value => (
      <Chip onClick={ () => this.onRemoveChipValue(value) } key={ value }>{ value }</Chip>
    ));
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Enter' && this.props.onEnterKeyPress) {
      this.props.onEnterKeyPress();
    }
  }

  render(props: MultiChipInputProps) {
    return (
      <div className={ cx('form-control hi-multichipin', { 'is-invalid': props.showInvalidState }) }>
        <div className="d-flex flex-wrap">
          { this.getChips() }
        </div>
        <input type="text" className="hi-multichipin__textinput"
          maxLength={ props.maxLength }
          onInput={ props.onInput }
          value={ props.textValue }
          placeholder={ props.placeholder }
          onKeyDown={ event => this.onKeyDown(event) } />
      </div>
    );
  }
}